import React from 'react';
import EnumsAdmin from './EnumsAdmin';
import Api from '../../api';

const TipoDeVehiculosAdmin = () => {
  return <EnumsAdmin enumType="Tipo de Vehiculo" apiService={Api.Enums.TipoDeVehiculos} />;
};

export default TipoDeVehiculosAdmin;
